import DialogContent from '@mui/material/DialogContent'
import uniqueId from 'lodash/uniqueId'
import { ChangeEvent, useState } from 'react'
import styled from 'styled-components'

import { SIZES } from '~/common/globalStyles'
import { withStyles } from '~/common/theme'
import { TagType } from '~/common/types/graphql'
import { AlertDialog } from '~/views/components/ui/Dialog'
import TextField from '~/views/components/ui/inputs/TextField'

import ColorDropdown from './ColorDropdown'

const styles = () => ({
  root: {
    willChange: 'auto !important',
  },
})

const Wrapper = styled.form`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 90px;
  grid-column-gap: ${SIZES.large};
`

export type TagColorItemData = Pick<TagType, 'id' | 'name' | 'color'>

interface Props {
  currentValues: TagColorItemData
  open: boolean

  editTag(tag: TagColorItemData): void

  tagId: TagType['id']

  onClose(): void

  focusInputField?: HTMLInputElement
  disabled?: boolean
  classes: { readonly [key: string]: string }
}

const EditDialog = ({
  currentValues,
  open,
  editTag,
  onClose,
  tagId: id,
  ...props
}: Props) => {
  const [color, setColor] = useState(currentValues.color || '')
  const [name, setName] = useState(currentValues.name || '')
  const formId = `form${uniqueId()}`

  return (
    <AlertDialog
      agreeText="Update"
      content={
        <DialogContent>
          <div id="alert-dialog-description">
            <Wrapper
              id={formId}
              onSubmit={(event) => {
                event.preventDefault()
                event.stopPropagation()
                editTag({ name, color, id })
              }}
            >
              <TextField
                required
                fullWidth
                value={name}
                disabled={props.disabled}
                placeholder="Create a New Tag"
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setName(event.target.value)
                }
                inputRef={(field: HTMLInputElement | null) => {
                  if (field) props.focusInputField = field
                }}
              />
              <ColorDropdown
                floating
                color={color}
                updateValue={(value: string) => {
                  setColor(value)
                }}
              />
            </Wrapper>
          </div>
        </DialogContent>
      }
      disagreeText="Cancel"
      AgreeButtonProps={{
        color: 'primary',
      }}
      DisagreeButtonProps={{ color: 'gray' }}
      onClose={onClose}
      onDisagree={onClose}
      onAgree={(event: any) => {
        event.preventDefault()
        event.stopPropagation()
        editTag({ name, color, id })
      }}
      open={open}
      title="Edit this tag"
      paperProps={{
        classes: {
          root: props.classes.root,
        },
      }}
    />
  )
}

export default withStyles(EditDialog, styles) as unknown as React.ComponentType<
  Omit<Props, 'classes'>
>
